import { useMemo } from 'react';
import { useBoardStore } from '../../services/board-store';
import { useGroupByFieldOld } from '../group-by';

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useIsColumnDroppableOld = (statusId: number): boolean | undefined => {
	const [{ transitions, cardDragState, issueFields }] = useBoardStore();
	const { issue } = cardDragState;
	const groupByField = useGroupByFieldOld();

	return useMemo(() => {
		// There's no drag in place, hence no need to disable columns
		const isDroppable =
			issue == null ||
			// The card status and column status is the same, card in drag is in this column
			issue.statusId === statusId ||
			transitions.some(
				(transition) =>
					// There's a global transition to this column and this column is not the source column
					(transition.isGlobal &&
						transition.toStatusId === statusId &&
						transition.fromStatusId !== statusId) ||
					// There's a transition from source column to this column
					(statusId === transition.toStatusId && issue.statusId === transition.fromStatusId),
			);
		if (issue != null && groupByField != null) {
			const field = issueFields?.[groupByField];
			const { issueTypeId } = issue;
			if (field == null || issueTypeId == null) {
				return isDroppable;
			}
			return field.issueTypes?.includes(issueTypeId);
		}
		return isDroppable;
	}, [groupByField, issue, issueFields, statusId, transitions]);
};
